export default "__VITE_ASSET__cf7396cc__"